module.exports = __webpack_public_path__ + "static/1-8c181835f166783dbda82cc960cc8c21.jpg";